import NewsDetailLayout from '../NewsDetailLayout';
import { shareWhitelabelData } from '../newsDetailData';

const ShareWhitelabelDetail = () => <NewsDetailLayout data={shareWhitelabelData} />;
export default ShareWhitelabelDetail;
